module.exports = __webpack_public_path__ + "img/violet_083.16ba11cb.png";